import PropTypes from 'prop-types';

const cohortSettingsShape = PropTypes.shape({
  bannerImage: PropTypes.string,
  bannerPattern: PropTypes.string,
  color: PropTypes.string,
});

export default cohortSettingsShape;
